/* eslint-disable camelcase */
export default {
  _carton_sixregular: 'carton_sixregular'
};